export default "__VITE_ASSET__BBAeewS2__"